import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import {Trans, useTranslation} from "react-i18next";
import {Col, Alert, Form, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";
import Children from "../Assets/Children";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

var serialize = require('serialize-javascript');
function FamilyChildren (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [Age, setAge]= useState()
    const [isLoading, setIsLoading] = useState(false);
    const { i18n } = useTranslation();

    const next = () =>{
        const family = JSON.parse(localStorage.getItem('family'))
        let nextLocation ={}

        if (family.Field19HasParents === "yes"){
            nextLocation = {
                pathname: '../family-parents',
                state: { d: d }
            }
        }else if (family.Field20HasPersons === "yes"){
            nextLocation = {
                pathname: '../family-other',
                state: { d: d }
            }
        }else if (Age > 15){
            nextLocation = {
                pathname: '../job',
                state: { d: d }
            }

        }else {
            nextLocation = {
                pathname: '../circumstances',
                state: { d: d }
            }
        }
        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const prevLocation = {
        pathname: '../family',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

    const [stored, setStored] =  useState("")

    const [Field280Number, setField280Number] = useState('')

    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const storedAge = localStorage.getItem('Age')
            setAge(storedAge)
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);

                const children = JSON.parse(localStorage.getItem('children'))
                if (children){
                    setChild(children)
                    setField280Number(Object.entries(children).length)
                    setStored(true)
                }


        };
        fetchData()
    }, []);


    const handleChangeNumber= (e)=> {
        e.preventDefault()
        setField280Number(e.target.value)
        setChildrenFormsOk(false)
        //console.log(child)
    }

    const [child, setChild] = useState([])
    const [childrenFormsOk, setChildrenFormsOk] =  useState(false)
    const submitChild = (childIndex, childObject) => {
        //console.log(childIndex)
        //console.log(childObject)
      //console.log(child)
        let cArray = child
        if (cArray[childIndex]){cArray[childIndex] = childObject}else{cArray.push(childObject)}

      //console.log(cArray)
        let children = serialize(cArray , {isJSON:true})
      //console.log(children)
        localStorage.setItem("children", children)
        if (Object.entries(child).length === parseInt(Field280Number)){
            setChildrenFormsOk(true)
        }

        setChild(cArray)
    }

    const deleteChild = ( childIndex) => {
        window.scrollTo(0, 0)
        //console.log(childIndex)
        //console.log(child)
        let cArray = child
        cArray.splice(childIndex,1)

        //console.log(cArray)
        let children = serialize(cArray , {isJSON:true})
        setChild(cArray)
        //console.log(children)
        localStorage.setItem("children", children)
        if (Field280Number > 0 ){
            setField280Number(Field280Number-1)
        }

    }

    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {
                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = Object.entries(child).length !== parseInt(Field280Number)
        //console.log(notValid)
        setNotValid(notValid)
        if (!notValid){
            next()
        }
    }

    const childForms = []
    for (let i= 0; i < Field280Number; i++){
        childForms.push(<Children i18n={i18n} d={d} key={i} index={i} delete={deleteChild} submitChild={submitChild} />)
    }

    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
<BreadCrumb n={3}/>
                    <Row>
                        <Col>

                            <h3>{ d? i18n.t("FAMILYTITLEDEATH"): i18n.t("FAMILYTITLE") }</h3>
                            <h4 className={"text-primary"}>{  d? i18n.t("CHILDRENFAMILYTITLEDEATH"): i18n.t("CHILDRENFAMILYTITLE") }</h4>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    <FormGroup className={(NotValid && Field280Number === "") ? "text-danger" : "text"}>
                                        <Label htmlFor="field280Number">{d? i18n.t("NUMBERCHILDRENDEATH"): i18n.t("NUMBERCHILDREN") } <span className={"text-danger"}>*</span></Label>
                                        <Input type="number"
                                               name="Field280Number" placeholder={d? i18n.t("PLACEHOLDERNUMBERCHILDRENDEATH"):i18n.t("PLACEHOLDERNUMBERCHILDREN")}
                                               onChange={handleChangeNumber} value={Field280Number || ''}  invalid={(NotValid && Field280Number === "")} />
                                        {(NotValid && Field280Number === "") &&<span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                                    </FormGroup>
                                    {Field280Number &&
                                        <div>
                                            {childForms}
                                        </div>
                                    }
                                    {(Object.entries(child).length === parseInt(Field280Number) || childrenFormsOk) &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{ !stored ?  i18n.t('Enregistrer') : i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }

                                </div>

                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default FamilyChildren

